import { defineComponent as _defineComponent } from 'vue'
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";
import AssessmentInstruction from "@/components/assessment-instruction-item-component.vue";
import StartExaminationComponent from "@/components/start-examination-component.vue";
import Loading from "../components/loading.vue";
import { Ref, computed, ref, onMounted } from "vue";
import Examination from "@/interfaces/examination.interface";
import useHttpRequest from "@/composables/use-http-request";
import GetStudentExaminationsDto from "@/dtos/get-student-examinations.dto";
import { useRoute, useRouter } from "vue-router/composables";
import { ExaminationErrorMessages } from "@/enums/examinationErrorMessages.enum";
import getFormattedStudentExaminationBlockingIssue from "@/helpers/getFormattedStudentExaminationBlockingIssue";
import OnlineAnswersheetInfoDialog from "@/components/dialogs/online-answersheet-info-dialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'examination-instructions',
  setup(__props) {

const isLoading = ref(true);
const examination: Ref<Examination | undefined> = ref();
const studentExamBlockingIssues: Ref<ExaminationErrorMessages[]> = ref([]);
const examinationSetFinancialRequirementPercentage = ref(0);
const percentageFeesPaid = ref(0);
const route = useRoute();
const router = useRouter();

const onlineAnswersheetInfoDialogVisible = ref(false);

const getExaminationInstructions = async () => {
  const request = await useHttpRequest<GetStudentExaminationsDto>({
    method: "GET",
    url: `examinations/fetch-exam-instructions/${
      route.params.examId
    }?timestamp=${new Date().getTime()}`,
    loadingProperty: isLoading,
    showSuccessMessage: false,
    errorLoadingProperty: null,
  });

  if (!request) {
    router.replace({ path: "/dashboard/examinations" });
    return;
  }
  if (
    request.success &&
    request.message == "Examination instructions fetched successfully"
  ) {
    examination.value = request.examination;
    studentExamBlockingIssues.value = request.studentExamBlockingIssues;
    percentageFeesPaid.value = request.percentageFeesPaid ?? 0;
    examinationSetFinancialRequirementPercentage.value =
      request.examinationSetFinancialRequirementPercentage ?? 0;
    examinationSetFinancialRequirementPercentage;

    //if the student has not started the exam yet, show the online answersheet dialog
    if (!examination.value?.student_examination_submissions?.length) {
      setTimeout(() => {
        onlineAnswersheetInfoDialogVisible.value = true;
      }, 500);
    }
  } else {
    router.replace({ path: "/dashboard/examinations" });
  }
};

/* 
   Since the exam may be on multiple intakes, then we need to avoid showing all modules on this exam
   as it may confuse the student i.e only show the one they clicked on the previous page and hide all the rest
   */
const userChosenModule = computed((): string => {
  let chosenModule = examination.value?.examination_intakes?.find(
    (intake) => intake.course_unit_id == route.params.courseUnitId
  );
  return chosenModule
    ? `${chosenModule.course_unit.course_unit_code} - ${chosenModule.course_unit.title}`
    : "";
});

onMounted(() => {
  getExaminationInstructions();
});

return { __sfc: true,isLoading, examination, studentExamBlockingIssues, examinationSetFinancialRequirementPercentage, percentageFeesPaid, route, router, onlineAnswersheetInfoDialogVisible, getExaminationInstructions, userChosenModule, BreadCrumbComponent, AssessmentInstruction, StartExaminationComponent, Loading, ExaminationErrorMessages, getFormattedStudentExaminationBlockingIssue, OnlineAnswersheetInfoDialog }
}

})